/**
 * External dependencies.
 */
import classnames from 'classnames';

/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';

import {
  Button,
  PanelBody
} from '@wordpress/components';

import { IoEllipsisVerticalCircleOutline, IoColorPaletteOutline } from 'react-icons/io5';
import { RiSettings5Fill } from 'react-icons/ri';
import { CiSliderHorizontal } from "react-icons/ci";
import { FaImage } from "react-icons/fa";
import { BsLightningCharge } from "react-icons/bs";
import { FaRegDotCircle } from "react-icons/fa";
import { GoVideo } from "react-icons/go";
import { MdOutlineArticle } from "react-icons/md";
/**
 * Internal dependencies.
 */

const LottieIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 400 400">
    <path d="M304.035 89.598c-68.951 0-94.382 49.158-114.885 88.663l-13.486 25.248c-21.74 41.899-37.964 67.35-79.781 67.35a19.756 19.756 0 0 0-13.995 5.784 19.769 19.769 0 0 0-4.291 21.56 19.758 19.758 0 0 0 10.713 10.702 19.756 19.756 0 0 0 7.573 1.499c68.951 0 94.382-49.158 114.885-88.663l13.405-25.248c21.74-41.899 37.964-67.35 79.781-67.35a19.763 19.763 0 0 0 18.286-12.201 19.77 19.77 0 0 0-4.291-21.56 19.763 19.763 0 0 0-13.995-5.784z" />
  </svg>
);

const FaqIcon = () => (
	<svg width="1em" height="1em" viewBox="0 0 24 24" fill="#6c1bc3" context="list-view" aria-hidden="true" focusable="false">
		<path d="M9.00006 9C9.50006 8 10.5001 7 12.0001 7C13.5002 7 15.0001 8.5 15.0001 10C15.0001 11.4553 14.0588 12.4399 13.0843 12.8686C13.0248 12.8948 12.9619 12.9116 12.8992 12.9285C12.4001 13.0627 12.0001 13.4804 12.0001 14M12.0001 17H12.0101M21.0001 12C21.0001 16.9706 16.9706 21 12.0001 21C10.5124 21 9.1091 20.6391 7.87286 20C7.19356 19.6488 3.56466 21.5054 3 21C2.43678 20.4959 4.93748 17.6302 4.51561 17C3.55833 15.5699 3.00006 13.8501 3.00006 12C3.00006 7.02944 7.0295 3 12.0001 3C16.9706 3 21.0001 7.02944 21.0001 12Z" fill="none" stroke="#6c1bc3" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">
		</path>
	</svg>
);

const FaqChildIcon = () =>(
	<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" context="list-view" aria-hidden="true" focusable="false">
    <path d="M12.0067 10.2C12.34 9.6 13.0067 9 14.0067 9C15.0067 9 16.0067 9.9 16.0067 10.8C16.0067 11.6628 15.394 12.2498 14.7527 12.5118C14.6977 12.5343 14.6397 12.5477 14.5824 12.5632C14.2608 12.6496 14.0067 12.8957 14.0067 13.2M14.0067 15H14.0133M11.0002 15H11.0069M8.00017 15H8.00684M21.0001 12C21.0001 16.9706 16.9706 21 12.0001 21C10.5124 21 9.1091 20.6391 7.87286 20C7.19356 19.6488 3.56466 21.5054 3 21C2.43678 20.4959 4.93748 17.6302 4.51561 17C3.55833 15.5699 3.00006 13.8501 3.00006 12C3.00006 7.02944 7.0295 3 12.0001 3C16.9706 3 21.0001 7.02944 21.0001 12Z" fill="none" stroke="#6c1bc3" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">
    </path>
  </svg>
);

export const VayuBlocksHeaderTab = ({
  value,
  options,
  onChange
}) => {
  const getIconComponent = (icon) => {
    switch (icon) {
      case 'colorwand':
        return IoEllipsisVerticalCircleOutline;
      case 'image':
        return FaImage;
      case 'lottie':
        return LottieIcon;
      case 'faq':
        return FaqIcon;
      case 'faq-child':
        return FaqChildIcon;
      case 'video':
        return GoVideo ;
      case 'diamond':
        return IoColorPaletteOutline;
      case 'colorpalette':
        return RiSettings5Fill;
      case 'slide':
        return CiSliderHorizontal;
      case 'icon':
          return BsLightningCharge;
      case 'toc':
        return MdOutlineArticle;
      case 'image-hotspot':
          return FaRegDotCircle;
      default:
        return null; // or a fallback component
    }
  };

  return (
    <PanelBody className="th-setting-header">
      {options.map((option, index) => {
        const IconComponent = getIconComponent(option.icon); // Dynamically generated component

        if (!IconComponent) {
          return null; // Skip rendering if the icon component is not found
        }

        return (
          <div key={index} className='th-tab-wrap'>
            <Button
              key={index}
              className={classnames({
                'is-active': option.value === value
              })}
              onClick={() => onChange(option.value)}
            >
			<IconComponent />
              {option.label}
            </Button>
          </div>
        );
      })}
    </PanelBody>
  );
};
